import React from 'react';
import { Divider, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import type { KlaviyoTestFormValues } from './KlaviyoTestFormTypes';

export type NewsletterFieldsProps = {
	form: UseFormReturnType<KlaviyoTestFormValues>;
	disabled: boolean;
};

export default function NewsletterFields(props: NewsletterFieldsProps) {
	const { form, disabled } = props;

	return (
		<>
			<Divider label="Newsletter signup" />
			<TextInput {...form.getInputProps('audienceType')} label="Audience type" disabled={disabled} />
			<TextInput {...form.getInputProps('parentInterest')} label="Parent interest" disabled={disabled} />
			<TextInput {...form.getInputProps('professionalType')} label="Professional type" disabled={disabled} />
			<TextInput {...form.getInputProps('signupSource')} label="Signup source" disabled={disabled} />
			<TextInput {...form.getInputProps('signupContextUrl')} label="Signup context URL" disabled={disabled} />
			<TextInput {...form.getInputProps('brandingType')} label="Branding type" disabled={disabled} />
		</>
	);
}
